/* eslint-disable no-nested-ternary , react/button-has-type */
import React from "react";
import "./CustomButton.css";

const CustomButton = ({
  children,
  startIcon,
  variant = "contained",
  color = "primary",
  size = "large",
  borderRadius = "rounded", 
  disabled = false,
  className = "",
  onClick,
  type = "button",
}) => {

const buttonType = ( type === "submit" ) ? "submit" : type === "reset"
    ? "reset"
    : "button";

  
  return (
    <button
      type={buttonType}
      className={`
        vf-btn
        vf-btn-${variant}
        vf-btn-${color}
        vf-btn-${size}
        vf-btn-${borderRadius}
        ${className}
      `}
      disabled={disabled}
      onClick={onClick}
    >
      {startIcon && (<span className="vf-btn-start-icon">{startIcon}</span>)}
      {children}
    </button>
  );
};

export default CustomButton;
